Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DWrapMode = module.exports.default = {
	CLAMP: "clamp",
	CLAMP_U_REPEAT_V: "clamp_u_repeat_y",
	REPEAT: "repeat",
	REPEAT_U_CLAMP_V: "repeat_u_clamp_y"
};